//helper
// import Account from '@/helper/AccountHelper.js';
import ConfigManager from "@/config/ConfigManager.js";
import CacheHelper from "@/helper/CacheHelper.js";
import Locale from '@/helper/locale/Locale.js';
// import Util from '@/helper/Utility.js';
import { CampaignType } from "@/helper/StaticValue.js";
//core
// import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';
//config
import {
    RedeemConfigBuilder,
    RedeemShippingAddressConfigBuilder
} from '@/core/Redeem/config/RedeemConfigBuilder.js';
//model
import { AddCartModel } from '@/core/Cart/model/CartModel.js';
import { WebInterfaceController } from './WebInterfaceController';
//service
import BzbsCart from '@/core/Cart/service/BzbsCart.js';
import IimmpactService from "../service/IimmpactService";
import { DrawDeliveryModel } from '@/core/Redeem/model/DrawDeliveryModel.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
// import { ModalController } from '../../../components/Modal/ModalController';

/**
 * event
 * @method onRedeemSuccess
 * @method onErrorApi
 * @method onRedirect
 */
export function RedeemController () {
    this.lbl = Locale.getLbl();
    this.localeCode = Locale.getLocaleCode();
    this.cacheHelper = new CacheHelper();
    this.token = null;

    this.campaign = {};
    this.selectedCampaignId = null;
    this.selectedQuantity = null;

    this.redeemConfigBuilder = new RedeemConfigBuilder();
    this.modal = null;

    // this.cbRedeemSuccess = new CallbackEvent();
    // this.cbRedirect = new CallbackEvent();
    // this.cbApiError = new CallbackEvent();

    //#region initial
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     * @param {modal} modal /components/Modal/ModalController.js
     */
    this.initial = (campaign, modal, token, apiPrefix, weblandingBlob) => {
        this.campaign = campaign;
        this.modal = modal;
        this.token = token;
        this.apiPrefix = apiPrefix;
        this.weblandingBlob = weblandingBlob;
    };
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     */
    this.reinitial = (campaign) => {
        this.lbl = Locale.getLbl();
        this.campaign = campaign;
    }
    //#endregion initial

    //#region redeem
    /**
     * Click ปุ่ม Redeem แล้วจะเรียกที่นี่
     *      - show popup confirm
     * @param {Number} selectedCampaignId campaign id
     * @param {Number} selectedQuantity quanty
     */
    this.clickRedeem = (selectedCampaignId, selectedQuantity) => {
        if (!this.onClickRedeem()) {
            return;
        }

        this.selectedCampaignId = selectedCampaignId;
        this.selectedQuantity = selectedQuantity;
        if (this.selectedQuantity > 1) {
            this.selectedQuantity = this.selectedQuantity * this.campaign.pointPerUnit;
        }
        this.modal.confirmRedeemModal
                            .clearModal()
                            .setCampaign(this.campaign)
                            .show()

        this.modal.confirmRedeemModal.onClickOk(() => {
            // event confirm redeem
            if (!this.onConfirmRedeem()) {
                return;
            }
            this.confirmRedeem();
        });

        this.modal.confirmRedeemModal.onClickCancel(() => {
            // event cancel redeem
            this.onCancelRedeem();
        });
    };

    /**
     * * Click popup Confirm Redeem แล้วจะเรียกที่นี่
     */
    this.confirmRedeem = () => {
        // //% Open web Campaign Type 8
        // if (this.isCampaignTypeInterFace()) {
        //     if (!this.onOpenInterface()) {
        //         return;
        //     }

        //     this.openWebInterface();
        // }

        // //% Open web Survey
        // else if (this.isCampaignTypeSurvey()) {
        //     var surveyUrl = this.campaign.website;
        //     this.onOpenInterface({ type: 'web', link: surveyUrl });
        // }

        // //% ไม่รู้คืออะไร เขียนไว้กันลืม
        // else if (this.isCampaignTypeApi()) {
        //     this.onOpenInterface();
        // }

        // //% Add item to cart
        // else if (this.isCampaignTypeBuy()) {
        //     if (!this.onAddToCart()) {
        //         return;
        //     }
        //     this.addToCart();
        // }

        // //% Open modal shipping
        // else if (this.campaign.delivered) {
        //     if (!this.onOpenShipping()) {
        //         return;
        //     }

        //     this.openDeliveryCampaign();
        // }

        // //% Normal Redeem
        // else {
        //     if (!this.onRedeem()) {
        //         return;
        //     }
        //     this.redeem();
        // }

        if (!this.onRedeem()) {
            return;
        }
        this.redeem();
    };

    /**
     * * Redeem delivery open shipping address
     */
    this.openDeliveryCampaign = function() {
        if (ConfigManager.getAddressType() == "profile") {
            this.modal.shippingAddressModal
                .clearModal()
                .setTitle(this.lbl.shipping.headline)
                .show();

            this.modal.shippingAddressModal.onSaveAddress(address => {
                if (!this.onSaveShipping()) {
                    return;
                }
                this.redeemConfigBuilder.redeemShippingAddressConfigBuilder = address;
                this.redeem();
            });
        } else if (ConfigManager.getAddressType() == "addressList") {
            this.modal.listAddressModal
                    .setNotShowModalAfterUpdate()
                    .show();
            this.modal.listAddressModal.onUpdateSuccess((address) => {
                if (!this.onSaveShipping()) {
                    return;
                }
                let addressBuilder = new RedeemShippingAddressConfigBuilder();
                addressBuilder.setAddressFromDeliveryAddressModel(address);
                this.redeemConfigBuilder.redeemShippingAddressConfigBuilder = addressBuilder;
                this.redeem();
            });
        } else {
            console.log("มึงเขียนคอนฟิก Shipping Address ผิด");
        }
    };

    /**
     * * Call api Redeem
     */
    this.redeem = () => {

        var params = this.redeemConfigBuilder.getRedeemParams();
        this.modal.loadingModal.show();
        IimmpactService.apiRedeemCampaign(this.selectedCampaignId, params, this.selectedQuantity, this.token, this.apiPrefix, this.weblandingBlob).subscribe({
            next: (campaign) => {
                this.modal.loadingModal.hide();
                this.campaign.updateAfterRedeem(campaign);

                this.initialSerial();
                this.onRedeemSuccess(campaign);
            },
            error: (err) => {
                this.modal.loadingModal.hide();
                this.onRedeemError(err);
                this.modal.alertModal.clearModal()
                    .setTitle('Error')
                    .setMsg('Redemption fail please try again')
                    .setBtnOk('Close')
                    .show()
            },
        })
    };
    //#endregion redeem

    //#region interface redeem open web
    this.openWebInterface = function () {
        let webInterface = new WebInterfaceController(this.campaign);
        webInterface.openInterface();


        //TODO: Setup link
        // var webUrl = this.campaign.website;
        // var isShowHeader = 'false';
        // var theme = ConfigManager.getAppName();
        // var suffledToken = Account.getTokenShuffle();

        // if (webUrl.indexOf('/Topup/InterfaceLanding') >= 0) {
        //     this.cacheHelper.setCache('isfromlanding', { page: 'interface' });
        // } else if (webUrl.indexOf('wondd') >= 0) {
        //     this.cacheHelper.setCache('isfromlanding', { page: 'wodd' });
        // } else {
        //     this.cacheHelper.setCache('isfromlanding', { page: 'other' });
        // }

        // webUrl += '&token=' + suffledToken
        //         + '&locale=' + this.localeCode
        //         + '&header=' + isShowHeader
        //         + '&theme=' + theme
        //     + '&return_url=' + encodeURIComponent(window.location.href);

        // // support history truemoney
        // if (webUrl.indexOf('wondd/truemoney') == -1 && webUrl.indexOf('truemoney') >= 0) {
        //     webUrl += '&history_url=' + encodeURIComponent(window.location.href + '/history');
        // }

        // window.location.href = webUrl;
    };
    //#endregion interface redeem open web

    //#region buy
    this.addToCart = () => {
        var cartItem = new AddCartModel();
        var cartParams = cartItem.addItem(this.selectedCampaignId, this.selectedQuantity)
                            .getParams();

        BzbsCart.apiAddToCart(cartParams).subscribe({
            next: (data) => {
                this.onAddToCartSuccess();
                console.log(data);
            },
            error: (err) => {
                this.onAddToCartError(err);
            },
        });
    };
    //#endregion buy

    //#region serial
    this.initialSerial = () => {
        if (this.campaign.delivered || this.campaign.type == CampaignType.Draw) {
            var drawDelivery = new DrawDeliveryModel();
            console.log(drawDelivery);
            drawDelivery.setModelFromDataModel(this.campaign);
            this.modal.drawDeliveryModal
                .setDrawDelivery(drawDelivery)
                .show();
        } else {
            var serial = new SerialModel();
            serial.setModelFromDataModel(this.campaign);
            this.modal.serialModal
                .setSerial(serial)
                .show();

            this.modal.serialModal.onCloseModal(data => {
                console.log(data);
            });
            this.modal.serialModal.onSerialExpire(data => {
                console.log(data);
            });
        }
    };
    //#endregion serial

    //#region event
    this.onClickRedeem = () => true;
    this.onConfirmRedeem = () => true;
    this.onCancelRedeem = () => true;
    this.onOpenInterface = () => true;
    this.onOpenShipping = () => true;
    this.onSaveShipping = () => true;
    this.onRedeem = () => true;
    this.onRedeemSuccess = () => true;
    this.onRedeemError = () => true;
    this.onAddToCart = () => true;
    this.onAddToCartSuccess = () => true;
    this.onAddToCartError = () => true;
    //#endregion event

    //#region private function
    this.isCampaignTypeInterFace = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'web');
    };
    this.isCampaignTypeSurvey = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'survey' || this.campaign.interfaceDisplay == 'surveyapprove');
    };
    this.isCampaignTypeApi = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'api');
    };
    this.isCampaignTypeBuy = function() {
        return (this.campaign.type == CampaignType.Buy);
    };
    //#endregion private function
}
